import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from "vuex";
import loader from "../modals/loader";
export default {
  data: function data() {
    return {
      sent: false,
      response: '',
      headers: [{
        text: 'Nombre Comercial',
        align: 'center',
        sortable: false,
        value: 'name'
      }, {
        text: 'Dirección',
        align: 'center',
        sortable: false,
        value: 'direccion'
      }, {
        text: 'Moneda',
        align: 'center',
        sortable: false,
        value: 'moneda'
      }, {
        text: 'Código',
        align: 'center',
        sortable: false,
        value: 'codigo'
      }],
      pagination: {
        rowsPerPage: 50,
        descending: false,
        page: 2

      }
    };
  },

  components: {
    loader: loader
  },
  methods: _extends({}, mapMutations({
    setLeaveToDashboard: "dashboard/details/setLeaveToDashboard",
    emptyData: "affiliations/form/emptyData"
  }), mapActions({
    downloadAffiliationToPrint: "affiliations/form/downloadAffiliationToPrint"
  }), {
    returnDashboard: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setLeaveToDashboard(true);
                _context.next = 3;
                return this.$store.commit('affiliations/form/finishAffiliation');

              case 3:
                this.$nextTick(function () {
                  this.emptyData();
                  this.$router.push("/dashboard");
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function returnDashboard() {
        return _ref.apply(this, arguments);
      }

      return returnDashboard;
    }()
  }),
  computed: _extends({}, mapState({
    commerceCode: function commerceCode(state) {
      return state.affiliations.form.commerceCode;
    },
    applyToCodeQR: function applyToCodeQR(state) {
      return state.affiliations.form.applyToCodeQR;
    },
    isVirtual: function isVirtual(state) {
      return state.affiliations.form.productType === '2';
    },
    dataTable: function dataTable(state) {
      return state.affiliations.form.dataTable;
    },
    infoTable: function infoTable(state) {
      return state.affiliations.form.infoTable;
    }
  }))
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/terms-multiAdress.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/terms-multiAdress.vue
// module chunks = 0 1 2 3